var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchInactive = function SvgSearchInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.584 18.333a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5M17.852 18.966c.486 1.466 1.595 1.613 2.448.33.779-1.174.266-2.136-1.146-2.136-1.045-.01-1.632.806-1.302 1.806"
  })));
};
export default SvgSearchInactive;